import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useSelector } from "react-redux";
import { FETCH_COMPANIES_PRODUCTS } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { BIGrey, BIRed, BIBlue } from "../../assets/helpers";
import SearchField from "../common/SearchField";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import AddCompanyWithRole from "../common/AddCompanyWithRole";
import { useDispatch } from "react-redux";
import { setShowReport } from "../../redux/actions/actions";
import Emptydata from "../common/Emptydata";
import InfiniteScroll from "react-infinite-scroll-component";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";

function ProductCompanySection({ id, scrollId, color="" }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, multiLanguageData, reportSuccess } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const LanguageData = multiLanguageData?.Products || {};
  const {
    TEXT_PRODUCT_COMPANIES_DESC = English.Products.TEXT_PRODUCT_COMPANIES_DESC,
    TEXT_SEARCH_PRODUCT_COMPANIES = English.Products.TEXT_SEARCH_PRODUCT_COMPANIES,
    TEXT_ADD_NEW_COMPANY = English.Products.TEXT_ADD_NEW_COMPANY,
    BUTTON_REPORT = English.Products.BUTTON_REPORT,
    TEXT_NO_RESULTS_FOUND = English.Products.TEXT_NO_RESULTS_FOUND,
    TEXT_NO_INFO_PRODUCT = English.Products.TEXT_NO_INFO_PRODUCT,
    TEXT_NO_INFO_PRODUCT_SUBTEXT = English.Products.TEXT_NO_INFO_PRODUCT_SUBTEXT,
    TEXT_ADD_COMPANY_TO_PRODUCT = English.Products.TEXT_ADD_COMPANY_TO_PRODUCT
  } = LanguageData || {};
  const debounceTimeout = useRef(null);
  const [companyData, setCompanyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchLoader, setShowSearchLaoder] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [showAddCompanyModal, setShowAddCompanyModal] = useState(false);
  const [product, setProduct] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  useEffect(() => {
    if (reportSuccess !== true) getInitialData();
  }, [reportSuccess]);

  const getInitialData = async () => {
    setIsLoading(true);
    await getCompanyData(searchTerm, 1, "fristTimeApiCall");
    setIsLoading(false);
  };

  const getCompanyData = async (searchTerm, pageNumber, fristTimeApiCall) => {
    try {
      setAllDataLoaded(true);
      const obj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 20,
        FullSearch: searchTerm ?? "",
        SearchList: [{ ProductId: id }],
        userId: currentUserId,
        IncludeRecordNr: true,
        SortList: [{ FieldName: "CompanyName", Direction: "ASC" }],
        FetchAllowedRecordsOnly: true,
        TypeOfObjectReturned: ""
      };
      const res = await Postrequestcall(FETCH_COMPANIES_PRODUCTS, obj, loginData?.accessToken);
      let resData =
        res?.data?.data?.sort((a, b) => a?.companyName?.localeCompare(b?.companyName)) ?? [];
      console.log("FETCH_COMPANIES_PRODUCTS resData:", resData);
      if (pageNumber > 1) {
        setTimeout(() => {
          setCompanyData((prevProducts) => [...prevProducts, ...resData]);
        }, 500);
      } else {
        setCompanyData(() => resData);
        // Set hasData for the first time API call
        if (fristTimeApiCall) {
          setHasData(resData?.length > 0);
        }
      }
    } catch (error) {
      console.log("getCompanyData-> Error While Fetching COmpanies Product: ", error);
    } finally {
      setShowSearchLaoder(false);
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      recordId: product.companyId ?? 0,
      name: Pages?.productCompanies?.name,
      AppScreenId: Pages?.productCompanies?.id
    };
    dispatch(setShowReport(reportObj));
  };

  const onAddProductClick = () => {
    setShowAddCompanyModal(true);
  };

  const onItemClick = (item) => {
    const isMfr =
      item?.manufacturer === true ||
      String(item?.manufacturer).toLowerCase() === "true" ||
      item?.manufacturer === 1 ||
      String(item?.isManufacturer).toLowerCase() === "true" ||
      item?.isManufacturer === true;

    const targetId = item?.companyId;
    if (!targetId) return;

    if (isMfr) {
      navigate(`/manufacture/${targetId}`);
    } else {
      navigate(`/company/${targetId}`);
    }
  };

  const onProductClick = (currentTarget, product) => {
    setProduct(product);
    setMoreMenuAnchorEl(currentTarget);
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const NoInformation = () => {
    return (
      <Stack  sx={{ gap: 1, height: "100%" }}>
        <Button variant="text" sx={{ alignSelf: "flex-end", color:color }} onClick={onAddProductClick}>
          {TEXT_ADD_NEW_COMPANY}
        </Button>
        <Box className="empty-data-card">
          <Emptydata
            icon={<BusinessCenterIcon className="emptydata-icon" />}
            firstText={TEXT_NO_INFO_PRODUCT}
            secondText={TEXT_NO_INFO_PRODUCT_SUBTEXT}
          />
        </Box>
      </Stack>
    );
  };

  const renderListing = () => {
    return (
      <Stack sx={{ gap: 1 }} >
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          {TEXT_PRODUCT_COMPANIES_DESC}
        </Typography>
        <SearchField
          placeholder={TEXT_SEARCH_PRODUCT_COMPANIES}
          value={searchTerm}
          onChange={(value) => {
            setShowSearchLaoder(true);
            const searchValue = value;
            setSearchTerm(searchValue);
            if (debounceTimeout.current) {
              clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
              getCompanyData(value, 1);
            }, 1000);
          }}
          onSubmit={() => {
            setShowSearchLaoder(true);
            setShowSearchLaoder(searchTerm);
            getCompanyData(searchTerm, 1);
          }}
          size={"small"}
        />
        <Button variant="text" sx={{ alignSelf: "flex-end", color:color }} onClick={onAddProductClick}>
          {TEXT_ADD_NEW_COMPANY}
        </Button>
        <Stack spacing={1}>
          {showSearchLoader ? (
            <Stack style={{ padding: "30px" }}>
              <Loader />
            </Stack>
          ) : companyData?.length > 0 ? (
            <>
              <InfiniteScroll
                dataLength={companyData?.length}
                next={async () => {
                  increaseOffset((pageNumber) => {
                    getCompanyData(searchTerm, pageNumber);
                  });
                }}
                hasMore={true}
                loader={
                  !allDataLoaded ? null : (
                    <h4 style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </h4>
                  )
                }
                scrollableTarget={scrollId}>
                <List disablePadding>
                  <Stack sx={{ gap: 1 }} >
                    {companyData.map((item) => (
                      <Card key={item?.id} className="pagelist-content">
                        <ListItem
                          key={item?.id}
                          style={{ padding: "0px" }}
                          secondaryAction={
                            <IconButton
                              onClick={(event) => onProductClick(event.currentTarget, item)}>
                              <MoreIcon />
                            </IconButton>
                          }>
                          <ListItemButton
                            onClick={() => {
                              onItemClick(item);
                            }}>
                            <ListItemText
                              primary={
                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                  {item?.companyName}
                                  {item?.verified && (
                                    <Tooltip title="This company has been verified" arrow>
                                      <VerifiedIcon sx={{ color: BIBlue, fontSize: "1.1rem", flexShrink: 0 }} />
                                    </Tooltip>
                                  )}
                                </Box>
                              }
                            />
                          </ListItemButton>
                        </ListItem>
                      </Card>
                    ))}
                  </Stack>
                </List>
                <Menu
                  anchorEl={moreMenuAnchorEl}
                  open={Boolean(moreMenuAnchorEl)}
                  onClose={() => setMoreMenuAnchorEl(null)}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}>
                  <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                    {BUTTON_REPORT}
                  </MenuItem>
                </Menu>
              </InfiniteScroll>
            </>
          ) : (
            <Stack sx={{ justifyContent: "center", alignItems: "center" }} direction={"row"} style={{ color: BIGrey, padding: "30px" }}>
              {TEXT_NO_RESULTS_FOUND}
            </Stack>
          )}
        </Stack>
      </Stack>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader /> : hasData ? renderListing() : <NoInformation />}
        {showAddCompanyModal && (
          <AddCompanyWithRole
            open={showAddCompanyModal}
            onClose={() => {
              setShowAddCompanyModal(false);
            }}
            title={TEXT_ADD_COMPANY_TO_PRODUCT}
            mainId={id}
            from="product"
            onDataSave={async () => {
              setShowAddCompanyModal(false);
              await getInitialData();
            }}
          />
        )}
      </Card>
    </Box>
  );
}

export default ProductCompanySection;

